import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const ValidatedDependencyRecord = Record({
  id: null,
  subject: null,
  object: null,
  dependencyType: null,
  isViolated: false
});

createFromJS.registerCallback(
  "ValidatedDependencyRecord",
  createFromJS.createPrimitiveCallback(ValidatedDependencyRecord)
);
